
import { Layout } from 'antd';
import { FC } from 'react';
import { FooterDesktop } from './footer/FooterDesktop';
import { FooterMobile } from './footer/FooterMobile';
import '../../App.less';

export const Footer:FC<{}> = (props) => {
    return(
        <Layout.Footer>
            <div className='help'>
                <div className='title'>
                    <p style={{color:"white"}}>¿Tienes alguna duda?</p>
                </div>
            </div>

            <FooterDesktop></FooterDesktop>

            <FooterMobile></FooterMobile>
        </Layout.Footer>
    )
}